import Vue from "vue"

export const documentStore = {
  state: {
    document: {
      document_activity_areas: [],
      document_doc_tags: []
    },
    documents: [],
    availableDocumentStateValues: [],
    availableDocumentKindValues: [],
    documentVersions: [],
    documentPagination: {}
  },
  mutations: {
    SET_DOCUMENT_PROPERTY(state, { key, value }) {
      Vue.set(state.document, key, value)
    },
    SET_DOCUMENTS(state, documents) {
      Vue.set(state, 'documents', documents)
    },
    SET_DOCUMENT(state, document) {
      Vue.set(state, 'document', document)
    },
    SET_DOCUMENT_VERSIONS(state, documentVersions) {
      Vue.set(state, 'documentVersions', documentVersions)
    },
    SET_AVAILABLE_DOCUMENT_STATE_VALUES(state, availableDocumentStateValues) {
      Vue.set(state, 'availableDocumentStateValues', availableDocumentStateValues)
    },
    SET_AVAILABLE_DOCUMENT_KIND_VALUES(state, availableDocumentKindValues) {
      Vue.set(state, 'availableDocumentKindValues', availableDocumentKindValues)
    },
    SET_DOCUMENT_PAGINATION(state, documentPagination) {
      Vue.set(state, 'documentPagination', documentPagination)
    }
  },
  actions: {
    getDocuments({ commit }, params) {
      return new Promise((resolve, reject) => {
        Vue.http.get('api/v1/documents', { params }).then(data => {
          if (data.ok) {
            commit('SET_DOCUMENTS', data.body.documents)
            commit('SET_DOCUMENT_PAGINATION', data.body.pagination)
            commit('SET_AVAILABLE_DOCUMENT_STATE_VALUES', data.body.available_document_state_values)
            commit('SET_AVAILABLE_DOCUMENT_KIND_VALUES', data.body.available_document_kind_values)
            commit('activityArea/SET_ACTIVITY_AREAS', data.body.activity_areas, { root: true })
            commit('docTag/SET_DOC_TAGS', data.body.doc_tags, { root: true })
            commit('subdivision/SET_MANAGEMENT_SUBDIVISION', data.body.management_subdivision, { root: true })
            commit('subdivision/SET_STRUCTURAL_SUBDIVISION', data.body.structural_subdivision, { root: true })
            resolve(data)
          }
        })
      })
    },
    getDocument({ commit }, documentId) {
      return new Promise((resolve, reject) => {
        Vue.http.get(`api/v1/documents/${documentId}`).then(data => {
          if (data.ok) {
            commit('SET_DOCUMENT', data.body.document)
            commit('SET_DOCUMENT_VERSIONS', data.body.versions || [])
            commit('documentFile/SET_DOCUMENT_FILE', data.body.document_file, { root: true })
            commit('documentFile/SET_DOCUMENT_FILES', data.body.document_files || [], { root: true })
            commit('initialOrder/SET_INITIAL_ORDER', data.body.initial_order || {}, { root: true })
            commit('changeOrder/SET_CHANGE_ORDER', data.body.change_order || {}, { root: true })
            commit('changeOrder/SET_CHANGE_ORDERS', data.body.change_orders || [], { root: true })
            resolve(data)
          }
        })
      })
    },
    getDocumentForCreate({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.http.get(`api/v1/documents/new`).then(data => {
          if (data.ok) {
            commit('SET_AVAILABLE_DOCUMENT_STATE_VALUES', data.body.available_document_state_values)
            commit('SET_AVAILABLE_DOCUMENT_KIND_VALUES', data.body.available_document_kind_values)
            commit('activityArea/SET_ACTIVITY_AREAS', data.body.activity_areas, { root: true })
            commit('docTag/SET_DOC_TAGS', data.body.doc_tags, { root: true })
            commit('subdivision/SET_SUBDIVISIONS', data.body.subdivisions, { root: true })
            resolve(data)
          }
        })
      })
    },
    getDocumentForEdit({ commit }, documentId) {
      return new Promise((resolve, reject) => {
        Vue.http.get(`api/v1/documents/${documentId}/edit`).then(data => {
          if (data.ok) {
            commit('SET_AVAILABLE_DOCUMENT_STATE_VALUES', data.body.available_document_state_values)
            commit('SET_AVAILABLE_DOCUMENT_KIND_VALUES', data.body.available_document_kind_values)
            commit('SET_DOCUMENT', data.body.document)
            commit('activityArea/SET_ACTIVITY_AREAS', data.body.activity_areas, { root: true })
            commit('docTag/SET_DOC_TAGS', data.body.doc_tags, { root: true })
            commit('documentFile/SET_DOCUMENT_FILE', data.body.document_file, { root: true })
            commit('initialOrder/SET_INITIAL_ORDER', data.body.initial_order || {}, { root: true })
            commit('subdivision/SET_SUBDIVISIONS', data.body.subdivisions, { root: true })
            resolve(data)
          }
        })
      })
    },
    createDocument({ commit }, params) {
      return new Promise((resolve, reject) => {
        Vue.http.post(`api/v1/documents`, params)
          .then(data => {
            if (data.ok) {
              commit('SET_DOCUMENT', {})
              resolve(data)
            }
          })
          .catch(error => {
            if (error.body?.errors) {
              commit('error/SET_ERRORS', error.body.errors, { root: true })
              reject(error)
            }
          })
      })
    },
    updateDocument({ commit }, { params, documentId }) {
      return new Promise((resolve, reject) => {
        Vue.http.patch(`api/v1/documents/${documentId}`, params)
          .then(data => {
            if (data.ok) {
              commit('SET_DOCUMENT', {})
              resolve(data)
            }
          })
          .catch(error => {
            if (error.body?.errors) {
              commit('error/SET_ERRORS', error.body.errors, { root: true })
              reject(error)
            }
          })
      })
    },
    deleteDocument({ commit }, documentId) {
      return new Promise((resolve, reject) => {
        Vue.http.delete(`api/v1/documents/${documentId}`).then(data => {
          if (data.ok) {
            commit('SET_DOCUMENT', {})
            resolve(data)
          }
        })
      })
    }
  },
  getters: {
    getDocumentVersionsCreatedAt: (state) => (index) => {
      return Vue.prototype
        .$dayjs(state.documentVersions[index].created_at)
        .format('DD.MM.YYYY H:mm')
    }
  }
}